import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import moment from 'moment';
import { communicationService } from "../../../services/communicationService";
import { commandKeys } from "../../../shared/commandKeys";
import {utils} from "../../../utils/shopifyInjector/utils";
import CommonConstants from "../../../utils/CommonConstants";

export default class CartController {
  static $inject = ['$scope', '$state', 'CartService', 'Session', 'AuthenticationService', 'Message',
    '$rootScope', 'CheckoutService', 'CartGroupsService', 'OrderSetupService', 'ConfigurationService',
    'cartonomyConfig', '$timeout', 'LocalForageService', '$translate'];

  constructor(scope, stateService, cartService, session, authenticationService, messageService,
    rootScope, checkoutService, cartGroupsService, orderSetupService, configurationService,
    cartonomyConfig, timeout, localForageService, $translate) {
    scope.groupSpending = "";
    scope.numbers = _.range(1, 10);
    scope.deleteItem = (item) => this._deleteItem(item);
    scope.payMyTab = () => this._payMyTab();
    scope.leaveOrder = () => this._leaveOrder();
    scope.quantityKeyPressed = ($event) => this._quantityKeyPressed($event);

    scope.showPayButton = () => this._shouldShowPayButton();
    scope.shouldShowStartIndividualPaymentButton = () => this._shouldShowStartIndividualPaymentButton();

    scope.clearCart = () => this._clearCart();
    scope.cancelOrder = () => this._cancelOrder();
    scope.canCancelOrder = () => this._canCancelOrder();
    scope.separatePayments = () => this._separatePayments();
    scope.startCheckoutProcess = (userId) => this._startCheckoutProcess(userId);
    scope.toggleCollapse = (group) => this._toggleCollapse(group);
    scope.updateQuantity = ($event, item, updateValue) => this._updateQuantity($event, item, updateValue);
    scope.backToCart = () => this._backToCart();
    scope.confirmStartCheckout = () => this._confirmStartCheckout();
    scope.goToOrderSettings = () => this._goToOrderSetting();
    scope.startNewOrder = () => this._startNewOrder();

    window.messageService = messageService;

    this._cartService = cartService;
    this._scope = scope;
    this._state = stateService;
    this._session = session;
    this._messageService = messageService;
    this._authenticationService = authenticationService;
    this._checkoutService = checkoutService;
    this._cartGroupsService = cartGroupsService;
    this._scope.loading = false;
    this._cartonomyConfig = cartonomyConfig;
    this._rootScope = rootScope;
    this._orderSetupService = orderSetupService;
    this._timeout = timeout;
    this._configurationService = configurationService;
    this._localForageService = localForageService;
    this.$translate = $translate;

    this._cartChanging = false;
    this._retailer  = null;
    this._scope.items = [];
    this._scope.checkOut = false;
    this._scope.groupsCollapses = {};
    this.quantityUpdating = false;
    this.quantityUpdateClicked = false;

    scope.updateSelectedTab = (number) => {
      scope.selectedTab = number;
    };

    scope.setQuantity = (item) => this._setQuantity(item);

    scope.startEditingItem = (item) => {
      item.isEditing = true;
    };

    scope.stopEditingItem = (item) => {
      setTimeout(() => {
        item.quantity = item.savedQuantity;
        item.isEditing = false;
        scopeUtils.apply(this._scope);
      }, 200);
    };

    scope.isStealthUserMode = this._session.getStealthUserMode();
    scope.showClearButtonCart = () => this._showClearButtonCart();
    scope.isGeneralMillsPOC = false;
  }
  
  async $onInit() {
    this._rootScope.storeWindowTitle = 'client.header.group_cart';
    this._scope.loading = await this._messageService.showLoadingWhiteBackground();
    this._retailer = await this._configurationService.getItem('retailer');
    this._scope.isGeneralMillsPOC = this._retailer && Constants.GENERAL_MILLS_POC.some((poc) => { return this._retailer.name.indexOf(poc) > -1});

    if (this._rootScope.safariWarningIsShowing) {
      await this._rootScope.displaySafariWarning();
    }

    if (utils.hash.indexOf('#/invite/') > -1) {
      this._rootScope.$on(Constants.Events.INVITATION_ACCEPTED, async () => {
        this.resetCartToEmpty();
        scopeUtils.apply(this._scope);
        await this._onCartChanged();
      });

      this._rootScope.$on(Constants.Events.INVITATION_FAILED_DUE_TO_CART_CLOSED, async () => await this.$onInit());

      if (await this._session.loggedIn()) {
        this.resetCartToEmpty();
        scopeUtils.apply(this._scope);
        await this._onCartChanged();
      }
    }

    await this._getAndSetupCart();

    if(this._scope.loading) {
      this._scope.loading.close();
      this._scope.loading = null;
    }
    scopeUtils.apply(this._scope);

    this._scope.$on(Constants.RootEvents.CART_CHANGED, () => this._onCartChanged());

    this._scope.$on(Constants.Events.WINDOW_STATE_CHANGED, _.debounce((scope, windowState) => this.onWindowStateChanged(windowState), 200));

    this._scope.$on(Constants.Events.ORDER_CANCELLED, async () => {
      this.resetCartToEmpty();
      scopeUtils.apply(this._scope);
      await this._onCartChanged();
    });

    this._scope.$on(Constants.Events.ORDER_CANCELLED_BY_OWNER, async () => {
      this.resetCartToEmpty();
      scopeUtils.apply(this._scope);
    });

    this._scope.$on(Constants.Events.ORDER_CLEARED_BY_OWNER, async () => {
      this.resetCartToEmpty();
      scopeUtils.apply(this._scope);
    });

    this._scope.$on(Constants.Events.ORDER_CHECKED_OUT, async () => {
      this.resetCartToEmpty();
      scopeUtils.apply(this._scope);
    });

  }

  _showClearButtonCart() {
    return this._retailer && this._retailer.retailerType !== 'Shopify';
  }

  _shouldShowStartIndividualPaymentButton() {
    if (this._scope.cart) {
      if (this._rootScope.retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing) {
        return this._scope.cart.cartStatus === 'OPEN' && moment().isAfter(moment(this._scope.cart.closeOn))
      }
      if (this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MIXED ||
          this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.FULL_MIXED ||
          this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.SELF) {
        return this._scope.cart.cartStatus === 'OPEN';
      }
    }

    return false;
  }

  _shouldShowPayButton() {
    if (this._scope.cart) {
      if (this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MIXED ||
          this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.FULL_MIXED ||
          this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.SELF) {
        return this._scope.isOwner ?
          this._scope.cart.cartStatus === 'OWNER_CHECKING_OUT' :
          this._scope.cart.cartStatus === 'CHECKING_OUT';
      }
    }

    return (!this._scope.isGroupOrder || this._scope.payAllowed) && !this._scope.paymentAuthorized;
  }

  async _clearCart(){
    let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.remove_confirm'),
        '',
        this.$translate.instant('client.yes'),
        this.$translate.instant('client.no'),
        'md-warn');
    if (!confirmed)
      return null;

    try{
      await this._cartService.clearCart();
      this._scope.items = [];
      this.resetCartToEmpty();
    }catch(error){
      this._messageService.showErrorPopupForResponse(error);
    }

    scopeUtils.apply(this._scope);
  }

  async _cancelOrder() {
    let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.group_cancel_confirm'),
        '',
        this.$translate.instant('client.yes'),
        this.$translate.instant('client.no'),
        'md-warn');

    if (!confirmed)
      return null;

    if (this._scope.cart.cartStatus === "CHECKING_OUT" || this._participants.some(p => p.paymentStatus === 1 && p.status !== 'OWNER' && p.items && p.items.length)) {
      confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.payment_done_cancel_confirm'))
    }

    if (!confirmed)
      return null;

    try {
      await this._cartService.deleteCart();
      await this._cartService.resetCartInvitationType();
      this._rootScope.$broadcast(Constants.Events.ORDER_CANCELLED);

      let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CART : Constants.RoutingStates.CATALOG;
      this._state.go(stateToGo);
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }

    scopeUtils.apply(this._scope);
  }

  async onWindowStateChanged(windowState) {
    if (windowState === Constants.WindowMode.maximized && this._scope.isCart()) {
      await this._checkOrderAvailable();
    }
  }

  async _onCartChanged() {
    if (this._cartChangeTimeout) {
      clearTimeout(this._cartChangeTimeout);
    }

    this._cartChangeTimeout = setTimeout(() => {
      clearTimeout(this._cartChangeTimeout);
      this._getAndSetupCart().then(() => {
        this.quantityUpdating = false;
        scopeUtils.apply(this._scope);
      });
    }, 500);
  }

  async _checkOrderAvailable() {
    let orderExists = false;
    if (this._cartonomyConfig.externalStoreMode) {
      if(this._orderSetupService.invitationPromise) {
        await this._orderSetupService.invitationPromise;
      }
      const isUserLoggedIn = await this._session.loggedIn();
      if(!isUserLoggedIn && !(utils.hash.indexOf('#/invite/') > -1)) {
        await this._authenticationService.showLoginDialog('', 'facade', true);
      }
      orderExists = await this._cartService.isGroupOrder();
      if (!orderExists) {
        if (!await this._orderSetupService.createOrder()) {
          return;
        }
      }
    }

    let cart = await this._cartService.getCart();
    orderExists = await this._cartService.isGroupOrder();

    if (cart && orderExists) {
      let cartOwner = _.find(cart.participants, participant => participant.status === `OWNER` || (this._scope.isStealthUserMode && participant.status === `REMOVED`));
      if (this._retailer.customCartNames === '1' && cart.cartName && cart.cartName !== this.$translate.instant(Constants.CART_NAME_DEFAULT_VALUE))
        this._scope.cartOwnerBtn = this.$translate.instant(utils.compileMyCartButtonText(cart.cartName), { user: cart.cartName });
      else
        this._scope.cartOwnerBtn = `${ this.$translate.instant('client.add_to') } ${ this.toPossessiveString(cartOwner && cartOwner.name) } ${ this.$translate.instant('client.header.group_cart') }`;

      this._scope.recentlyAddedProduct = this._rootScope.addingProduct && this._rootScope.addingProduct.variantId;
      await this._setupCart(cart);
    }
  }

  toPossessiveString(name) {
    if (name[name.length - 1] == 's') {
      return `${name}'`;
    }

    return `${name}'s`;
  }

  async _setQuantity(item, recursiveChangeValue) {
    if (item < 1) {
      return;
    }
    try {
      await this._updateItem(item);
      await this._updateGroups();
    } catch (error) {
      item.quantity -= recursiveChangeValue;
      scopeUtils.apply(this._scope);
      await this.__setQuantityRecursively(item, recursiveChangeValue);
    }
  }

  async __setQuantityRecursively(item, recursiveChangeValue) {
    if(item.savedQuantity === item.quantity || item.quantity < 1) {
      this.quantityUpdating = false;
      return;
    }
    try {
      await this._updateItem(item);
    } catch (error) {
      item.quantity -= recursiveChangeValue;
      scopeUtils.apply(this._scope);
      await this.__setQuantityRecursively(item, recursiveChangeValue);
    }
  }

  async _updateItem(item) {
    try {
      await this._cartService.updateItem(item);
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
      throw error;
    }
  }

  _quantityKeyPressed($event) {
    if ($event.which !== 13) {
      return;
    }

    $event.target.blur();
  }

  async _deleteItem(item) {

    try {
      await this._cartService.deleteItem(item.id);
      for (let i = 0; i < this._scope.items.length; i++) {
        if (this._scope.items[i].id === item.id) {
          this._scope.items.splice(i, 1);
          break;
        }
      }
      await this._updateGroups();
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  async _updateGroups() {
    if (this._scope.items.length) {
      const recentUpdated = _.maxBy(this._scope.items, item => item.recordedOn);

      if (recentUpdated)
        recentUpdated.recentlyUpdated = true;
    }

    this._scope.groups = await this._cartGroupsService.groupItems(this._scope.items, this._participants);
    this._scope.myTab = _.find(this._scope.groups, { myTab: true });
    this._scope.groupSpending = _.sumBy(this._scope.groups, (group) => group.subtotal);
    if (this._scope.myTab && this._scope.cart) {
      this._scope.myTapDiscounted = this._scope.myTab.subtotal - this._scope.cart.cartDiscount;
    }

    scopeUtils.apply(this._scope);
  }

  async _getAndSetupCart() {
    await this._checkOrderAvailable();
    scopeUtils.apply(this._scope);
  }

  resetCartToEmpty() {
    this._scope.groups = null;
    this._scope.myTab = null;
    this._scope.groupSpending = null;
    this._scope.myTapDiscounted = null;
  }

  async _setupCart(cart) {
    if (!cart) {
      this.resetCartToEmpty();
      return;
    }

    this._scope.groupAllowance = cart.orderLimit;
    this._scope.isGroupOrder = await this._cartService.isGroupOrder(cart);
    this._scope.cart = cart;
    this._scope.cart = await this._cartService.getCart();
    this._scope.orderExists = await this._cartService.isGroupOrder();

    if (!cart.closeOn) {
      this._scope.orderDeadline = `${this.$translate.instant('client.order.deadline')}: ${this.$translate.instant('client.none')}`;
    } else if (moment.utc(cart.closeOn).isBefore(moment())) {
      this._scope.orderDeadline = `${this.$translate.instant('client.order.deadline')}: ${this.$translate.instant('client.order.closed_br')}<br />`;
      let currentUser = await this._session.getUserEmail();
      let currentParticipant = _.find(cart.participants, (participant) => participant.email == currentUser);
      if (currentParticipant && currentParticipant.status === "OWNER") {
        this._scope.orderDeadline += `${this.$translate.instant('client.order.deadline_open')}`;
      }
    } else {
      this._scope.orderDeadline = `${this.$translate.instant('client.order.deadline')}: ${moment().to(moment.utc(cart.closeOn))}`;
    }

    this._scope.isOwner = await this._cartService.isOwner(cart);
    this._scope.canDeleteItem = this._retailer.cartonomyMode !== Constants.CartonomyMode.marketing;
    this._scope.marketingMode = this._retailer.cartonomyMode === Constants.CartonomyMode.marketing;

    this._scope.items = _.cloneDeep(cart.items);
    this._scope._itemsCount = _.sumBy(this._scope.items, (item) => item.quantity);
    this._participants = cart.participants;
    this._scope.paymentAuthorized = await this._checkoutService.paymentAuthorizedOrCaptured();

    this._participants.forEach(participant => {
      participant.items = this._scope.items.filter(item => item.participantEmail === participant.email);
    });

    this._scope.awaitPayment = this._participants.filter(p => p.paymentStatus === 0 && p.status !== 'OWNER' && p.items.length).length;

    if (cart.cartStatus === 'CHECKING_OUT') {
      this._scope.paymentStatusMessage = this._scope.awaitPayment === 0 ? this.$translate.instant('client.order.checkout_complete') : `${this._scope.awaitPayment} ${this._scope.awaitPayment > 1 ? this.$translate.instant('client.order.people_need') : this.$translate.instant('client.order.people_needs')} ${this.$translate.instant('client.order.to_pay')}`;
    }

    if(cart.cartStatus === 'OPEN') {
      this._scope.isAllowChangeQuantity = true;
    }

    this._scope.groupPay = cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MULTIPLE;

    if (this._scope.groupPay) {
      this._scope.payAllowed = true;
    } else if (!this._scope.isGroupOrder) {
      this._scope.payAllowed = true;
    } else {
      this._scope.payAllowed = this._scope.isOwner && !(this._scope.paymentAuthorized);
    }

    _.each(this._scope.items, (item) => {
      item.savedQuantity = item.quantity;
      if (!item.catalogProductImage) {
        item.catalogProductImage = Constants.DEFAULT_PRODUCT_IMAGE;
      }
    });

    await this._updateGroups();
  }

  async _leaveOrder() {
    let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.leave_order'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

    if (!confirmed)
      return null;

    try {
      await this._cartService.leaveCart();
      this._scope.overlayOpened = false;
      if (this._cartonomyConfig.externalStoreMode) {
        await this._rootScope.$broadcast(Constants.Events.LEFT_ORDER);
      } else {
        this._state.go(Constants.RoutingStates.CATALOG);
      }


      this._messageService.showErrorPopup(this.$translate.instant('client.order.left_order'));
    } catch (error) {
      this._scope.overlayOpened = false;
      scopeUtils.apply(this._scope);
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  async _separatePayments() {
    let confirmed = await this._messageService.showQuestionPopup(
      this.$translate.instant('client.cart.proceed_with_email'),
      '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

    if (!confirmed)
      return null;

    await this._cartService.checkOutCart();
    this._rootScope.$broadcast(Constants.RootEvents.CART_CHANGED);
  }

  /**
   * Check out by owner only
   */
  async _startCheckoutProcess(userId) {
    // CW-2645
    if (this._scope.cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.FULL_MIXED && this._scope.isOwner && !userId) {
      this._state.go(Constants.RoutingStates.CHECKOUT_FULL_MIXED);
      return;
    }

    // let confirmed = await this._cartService.startProcessCheckout();
    // if (!confirmed)
    //   return null;

    if (!this._cartonomyConfig.externalStoreMode) {
      this._state.go(Constants.RoutingStates.CHECKOUT);
    }
    else {
      try {
        let retailer = await this._configurationService.getItem('retailer');

        // Amazon
        if (retailer.retailerType === 'Amazon') {
          await this._amazonCheckout();
        }
        else if (retailer.retailerType === 'Walmart') {
          await this._walmartCheckout();
        }
        else if (retailer.retailerType === 'Freshop') {
          await this._freshopCheckout();
        }
        else {
          await this._shopifyCheckout(userId);
        }
      } catch (error) {
        this._messageService.showErrorPopupForResponse(error);
      }
    }
    this._rootScope.$broadcast(Constants.RootEvents.CART_CHANGED);
  }

  /**
   * Check out for mixed mode - pay personally
   */
  async _payMyTab() {
    if (!this._cartonomyConfig.externalStoreMode) {
      this._state.go(Constants.RoutingStates.CHECKOUT);
    }
    else {
      try {
        let retailer = await this._configurationService.getItem('retailer');

        if (retailer.retailerType === 'Amazon') {
          await this._amazonCheckout();
        }
        else if (retailer.retailerType === 'Walmart') {
          await this._walmartCheckout();
        }
        else if (retailer.retailerType === 'Freshop') {
          await this._freshopCheckout();
        }
        else {
          await this._shopifyCheckout();
        }
      }
      catch (error) {
        this._messageService.showErrorPopupForResponse(error);
      }
    }
  }

  _canCancelOrder() {
    return this._scope.cart && this._scope.isOwner;

  }

  async _amazonCheckout() {
    let loadingDialog = await this._messageService.showLoading();

    let amazonCheckoutInfo = await this._checkoutService.getAmazonCheckoutInfo();

    await communicationService.requestToParent(commandKeys.checkoutCart, {
      cartInfo: amazonCheckoutInfo.cartInfo,
      checkoutUrl: amazonCheckoutInfo.url
    });

    loadingDialog.close();
  }

  async _shopifyCheckout(userId) {

    let loadingDialog = await this._messageService.showLoading();
    try {
      const shopifyCheckoutInfo = await this._checkoutService.getShopifyCheckoutInfo(userId);
      const myCartItems = shopifyCheckoutInfo.cartInfo.cartItems;

      if (shopifyCheckoutInfo.warningInfo) {
        loadingDialog.close();
        const continueCheckout = await this._messageService.showQuestionPopup(shopifyCheckoutInfo.warningInfo, '', this.$translate.instant('client.cart.continue_checkout') , this.$translate.instant('client.cart.checkout_review'));
        if (!continueCheckout) {
          return;
        }

        loadingDialog = await this._messageService.showLoading();
      }

      const existingShopifyCartItems = await communicationService.requestToParent(commandKeys.checkCartItems, {});
      const hasMyCartItems = existingShopifyCartItems.data.items.some(item => myCartItems.some(myCart => item.id === myCart.id));

      if (existingShopifyCartItems.data.item_count > 0) {
        if (hasMyCartItems) {
          loadingDialog.close();
          const continueCheckoutWhenMatch = await this._cartService.confirmContinueCheckoutWhenMatchCartItems();

          if (!continueCheckoutWhenMatch) {
            return;
          }
          loadingDialog = await this._messageService.showLoading();
        } else {
          loadingDialog.close();
          const continueCheckout = await this._cartService.confirmContinueCheckout();
          if (!continueCheckout) {
            return;
          }
          loadingDialog = await this._messageService.showLoading();
        }
      }

      const checkoutResult = await communicationService.requestToParent(commandKeys.checkoutCart, {
        cartInfo: shopifyCheckoutInfo.cartInfo
      });

      if (!checkoutResult.success) {
        loadingDialog.close();
        this._messageService.showErrorPopup(checkoutResult.errorMessage);
      } else {
        loadingDialog.close();
      }
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    } finally {
      loadingDialog.close();
    }

  }

  async _walmartCheckout() {
    let loadingDialog = await this._messageService.showLoading();

    const walmartCheckoutInfo = await this._checkoutService.getWalmartCheckoutInfo();
    const myCartItems = walmartCheckoutInfo.cartInfo;

    const checkoutResult = await communicationService.requestToParent(commandKeys.checkoutCart, {
      cartItems: myCartItems
    });

    if (!checkoutResult.success) {
      loadingDialog.close();      
      await this._messageService.showErrorPopup(checkoutResult.errorMessage);
    } else {
      loadingDialog.close();
    }
  }

  async _freshopCheckout() {
    let loadingDialog = await this._messageService.showLoading();

    const freshopCheckoutInfo = await this._checkoutService.getFreshopCheckoutInfo();
    const myCartItems = freshopCheckoutInfo.cartInfo;

    const isItemsResp = await communicationService.requestToParent(commandKeys.checkCartItems, {});
    if (!isItemsResp.success) {
      const continueCheckout = await this._cartService.confirmContinueCheckout('Freshop');
      if (!continueCheckout) {
        return;
      }
    }
    const checkoutResult = await communicationService.requestToParent(commandKeys.checkoutCart, {
      cartItems: myCartItems,
      storeId: this._scope.cart.retailerStoreId
    });

    if (!checkoutResult.success) {
      loadingDialog.close();
      await this._messageService.showErrorPopup(checkoutResult.errorMessage);
    } else {
      loadingDialog.close();
    }
  }

  _toggleCollapse(group) {
    this._scope.groupsCollapses[group.participant.userId] = !this._scope.groupsCollapses[group.participant.userId];
  }

  async _updateQuantity($event, item, updateValue) {
    if (this.qtyChangeTimeout) {
      clearTimeout(this.qtyChangeTimeout);
    } else {
      item.savedQuantity = item.quantity;
    }
    
    if(this.quantityUpdating) {
      return;
    }

    item.quantity += updateValue;

    this.qtyChangeTimeout = setTimeout(async () => {
      this.quantityUpdating = true;
      await this._setQuantity(item, updateValue);
    }, 1000);

  }

  _backToCart() {
    this._state.go(Constants.RoutingStates.CART);
  }

  _confirmStartCheckout() {
    this._state.go(Constants.RoutingStates.START_CHECKOUT);
  }

  async _copyClipboard() {
    this._cartService.copyClipboard(this._scope.invitationLink);
  }

  async _goToOrderSetting() {
    try {
      this._scope.overlayOpened = false;
      scopeUtils.apply(this._scope);
      await this._orderSetupService.editOrder('preview');
      await this._onCartChanged();
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  async _startNewOrder() {
    await  this._orderSetupService.createOrder();
  }
}



// WEBPACK FOOTER //
// ./src/modules/cart/controllers/CartController.js